<template>
  <dd-header-card
      class="automation-card"
      @click="$emit('click')"
      :active="isActive"
      :header="automation.title"
  >
    <template #icon>
      <dd-icon icon="mdi mdi-account-star" class="color-primary" size="lg"/>
    </template>
    <template #action>
      <div class="flex-row align-items-center gap-sm">
        <automation-next-run-component :automation-interface="automation"/>

        <ExecuteOnceButton v-if="runsOnce" :automation-interface="automation"/>
        <automation-execution-switch
            v-else
            @saved="fetchAutomationables(true)"
            :automation="automation">
          <template #button="{ isActive }">
            <dd-switch
                class="automation-execution-switch"
                :value="isActive">
              <AutoRenewIcon class="icon-size-md icon-offset-zero" slot="checkedChildren"/>
              <CloseIcon class="icon-size-lg icon-offset-zero" slot="unCheckedChildren"/>
            </dd-switch>
          </template>
        </automation-execution-switch>
      </div>
    </template>
    <div class="flex-col justify-content-between gap-md">
      <div class="automation-card-content">
        <p v-if="runIntervalDescription === RunIntervalEnum.NEVER">
          Automation staat niet aan.
        </p>
        <p v-else-if="runIntervalDescription === RunIntervalEnum.ONCE">
          Automation is <strong>nog niet</strong> uitgevoerd.
        </p>
        <p v-else-if="runIntervalDescription === 'not_yet_executed'">
          Automation is <strong>eenmalig</strong> en nog niet uitgevoerd
        </p>
        <p v-else>
          Automation <strong>{{ intervalDescription }}</strong> uitvoeren.
          De volgende uitvoering start op <strong>{{ nextSendDate }}</strong>
        </p>
      </div>
      <div class="flex-row align-items-center justify-content-between">
        <AutomationSelectionSummary :automation="automation"/>
        <AutomationIconComponent
            v-bind:is-active="isActive"
            v-bind:creates-signal="createsSignal"
            v-bind:creates-task="createsTask"
            v-bind:sends-email="sendsEmail"
            v-bind:is-recurring="isRecurring"
            v-bind:is-data-enrichment="isDataEnrichment"
            v-bind:is-campaign="isCampaign"
            v-bind:is-selection="isSelection"
        />
      </div>
    </div>
  </dd-header-card>
</template>

<script>
import { mapActions } from 'vuex'
import { AutomationHelper } from '~/pages/automation/helpers'
import { AutomationTypeEnum, RunIntervalEnum } from '~/pages/automation/enums'
import ExecuteOnceButton from './ExecuteOnceButton.vue'
import AutomationExecutionSwitch from '../AutomationExecutionSwitch.vue'
import AutomationIconComponent from '../AutomationIconComponent.vue'
import AutomationSelectionSummary from '../AutomationSelectionSummary.vue'
import AutomationNextRunComponent from '../AutomationNextRunComponent.vue'
import AutomationItemMixin from '~/mixins/automations/AutomationItem'

export default {
  name: 'AutomationCard.vue',
  components: {
    ExecuteOnceButton,
    AutomationExecutionSwitch,
    AutomationIconComponent,
    AutomationSelectionSummary,
    AutomationNextRunComponent,
  },
  mixins: [AutomationItemMixin],
  props: {
    automation: {
      title: {
        type: String,
      },
      required: true,
    }
  },
  data () {
    return {
      RunIntervalEnum,
    }
  },
  methods: {
    ...mapActions({
      fetchAutomationables: '$_automation/fetchAutomationables',
    }),
    onActivateClick (isActive) {
      if (!isActive) {
        event.stopPropagation()
      }
      this.$emit('activate', this.automation)
    },
  },
  computed: {
    runsOnce () {
      return this.automation.run_interval === RunIntervalEnum.ONCE
    },
    automationType () {
      return this.automation.type ?? this.automation.globalAutomation?.type
    },
    isActive () {
      return AutomationHelper.isActive(this.automation)
    },
    createsSignal () {
      return this.automationConfiguration.create_signal || false
    },
    createsTask () {
      return this.automationConfiguration.create_task || false
    },
    sendsEmail () {
      return this.automationConfiguration.send_email || false
    },
    isRecurring () {
      return this.automationConfiguration.is_recurring || false
    },
    isCampaign () {
      return this.automationType === AutomationTypeEnum.CAMPAIGN
    },
    isSelection () {
      return this.automationType === AutomationTypeEnum.SELECTION
    },
    isDataEnrichment () {
      return this.automationType === AutomationTypeEnum.DATA_ENRICHMENT
    },
    automationConfiguration () {
      return this.automation
    },
  }
}
</script>
